export default __webpack_public_path__ + "static/media/gabi-avatar.7b74ce0c.jpg";